<template>
    <dialog v-if="visible">
        <p>You are about to navigate away from the Course. Are you sure you want to leave?</p>
        <button @click="okHandler">Im Sure</button>
        <button @click="closeHandler">Cancel</button>
    </dialog>
</template>
<script>
export default {
  name: 'DialogBox',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    okHandler() {
      this.$emit('onChange', true);
    },
    closeHandler() {
      this.$emit('onChange', false);
    }
  }
};
</script>
